import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getUser, getUserSocket } from "../../api/user";

export const fetchUser = createAsyncThunk(
  "user/fetchUser", async (limit, thunkAPI) => {
    try {
      return getUser()
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);

export const fetchUserSocket = createAsyncThunk(
  "user/fetchUserSocket", async (limit, thunkAPI) => {
    try {
      return getUserSocket()
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);

export const taskSlice = createSlice({
  name: 'user',
  initialState: {
    user: {},
    isLoggedin: false,
    socket: false,
    loading: null,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUser.pending, (state) => {
      state.data = [];
      state.loading = "loading";
    });
    builder.addCase(
      fetchUser.fulfilled, (state, { payload  }) => {
        state.user = payload.user;
        state.isLoggedin = payload.isLoggedin;
        state.loading = "loaded";
      }
    );
    builder.addCase(
      fetchUser.rejected,(state, action) => {
        state.loading = "error";
        state.error = action.error.message;
      }
    );
    builder.addCase(
      fetchUserSocket.fulfilled, (state, { payload  }) => {
        state.socket = payload;
      }
    );
  }
})

// Action creators are generated for each case reducer function
export const { add } = taskSlice.actions
//
export default taskSlice.reducer
